import CaptainDocumentAPI from 'dashboard/api/captain/document';
import { createStore } from './storeFactory';

export default createStore({
  name: 'CaptainDocument',
  API: CaptainDocumentAPI,
  actions: mutationTypes => ({
    async silentGet({ commit }, params = {}) {
      try {
        const response = await CaptainDocumentAPI.get(params);
        commit(mutationTypes.SET, response.data.payload);
        commit(mutationTypes.SET_META, response.data.meta);
      } catch (error) {
        // Silenciar errores durante polling
      }
    },
    async changeTeam({ commit }, { documentId, teamId }) {
      try {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
        const response = await CaptainDocumentAPI.changeTeam(documentId, teamId);
        commit(mutationTypes.EDIT, response.data);
        return response.data;
      } catch (error) {
        throw error;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },
    async rename({ commit }, { documentId, name }) {
      try {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
        const response = await CaptainDocumentAPI.rename(documentId, name);
        commit(mutationTypes.EDIT, response.data);
        return response.data;
      } catch (error) {
        throw error;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },
    async reprocess({ commit }, documentId) {
      try {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
        await CaptainDocumentAPI.reprocess(documentId);
      } catch (error) {
        throw error;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },
    async regenerateFaqs({ commit }, documentId) {
      try {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
        await CaptainDocumentAPI.regenerateFaqs(documentId);
      } catch (error) {
        throw error;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },
    async destroyFailed({ commit }) {
      try {
        commit(mutationTypes.SET_UI_FLAG, { deletingItem: true });
        const response = await CaptainDocumentAPI.destroyFailed();
        return response.data;
      } catch (error) {
        throw error;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { deletingItem: false });
      }
    },
  }),
});
